import React from 'react';
import NewsletterRegisterComponent from '../../../components/admin/newsletter/NewsletterRegisterComponent';

const NewsletterRegister: React.FC = () => {
  return <NewsletterRegisterComponent />;
};

export default NewsletterRegister;
